<script>
import _merge from 'lodash/merge'
import _cloneDeep from 'lodash/cloneDeep'

import ProductParamItem from './ProductParamItem'

export default {
  components: { ProductParamItem },

  props: {
    data: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      default: () => {},
    },
    maxValue: {
      type: Number,
      required: true,
    },
    valueSizeTotal: {
      type: Number,
      default: 0,
    },
    valuePriceTotal: {
      type: Number,
      default: 0,
    },
    selectPrepaid: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      /* valueSizeTotal: '',
      valuePriceTotal: '', */
    }
  },
  computed: {
    paramsWithQty() {
      return _merge(_cloneDeep(this.data), this.value);

    },
    paramsWithoutNoQty() {
      return Object.values(this.paramsWithQty).filter((param) => param.selectQty)
    },
  },
  watch: {
    value: {
      deep: true,
      handler(value) {
        this.updateTotal(value);
      },
    },
  },
  mounted() {
    this.updateTotal(this.value);
  },
  methods: {
    updateTotal(paramsValue) {
      const getPropTotal = (property) => {
        const qtyPropArray = Object.values(paramsValue).map((param) => {
          return param.selectQty * param[property]
        });

        return qtyPropArray.length !== 0
          ? qtyPropArray.reduce((prev, curr) => prev + curr)
          : 0
      };

      this.$emit('update:valueSizeTotal', getPropTotal('size'));
      this.$emit('update:valuePriceTotal', getPropTotal('price'));
    },
    handleParamMaxQty(size) {
      const maxValue = this.maxValue;
      const restSize = maxValue - this.valueSizeTotal;

      const selectedSize = restSize >= size ? Math.floor(this.valueSizeTotal / size) : 0;

      return Math.floor(restSize / size) + selectedSize
    },
    updateSelectedValue(selectQty, param) {
      const _tempValue = Object.assign({}, this.value);
      const paramIsSelected = this.value[param.alias];
      const paramObj = {
        ...param,
        selectQty,
      };

      if (paramIsSelected && selectQty === 0) {
        delete _tempValue[param.alias]
      } else {
        _tempValue[param.alias] = paramObj
      }

      this.$emit('update:value', _tempValue);
    },
  },
}
</script>

<template>
  <div>
    <ProductParamItem
      v-for="(param, paramKey) in paramsWithQty"
      :key="paramKey"
      :data="param"
      :select-qty="param.selectQty"
      :max-qty="handleParamMaxQty(param.size)"
      @change="(selectQty) => {
        updateSelectedValue(selectQty, param)
      }"
    />
  </div>
</template>
